// @flow
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import * as signals from '../../../application/signals';
import InlinePrivacy from './InlinePrivacy';

const mapStateToProps = (state) => ({
  cookies: [
    {
      name: 'analytics',
      optOut: true,
    },
    {
      name: 'marketing',
      optOut: true,
    },
    {
      name: 'support',
      optOut: true,
    },
    {
      name: 'essential',
      optOut: false,
    },
  ],
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  submitForm: signals.submitForm,
}, dispatch);

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    onSubmit: ({ submitForm }) => (values) => new Promise((resolve, reject) => {
      submitForm(values);
    }),
  }),
  reduxForm({
    form: 'inlinePrivacy',
    propNamespace: 'form',
  }),
);

export default enhance(InlinePrivacy);



// WEBPACK FOOTER //
// ./src/presentation/components/inline-privacy/ConnectedInlinePrivacy.js